module.exports = __webpack_public_path__ + "static/media/why-choose-img3.c001363a.jpg";